import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
//
import { Row, Card, Col, Button } from "react-bootstrap";
//
import PageHeader from "../../../components/general/PageHeader";
import TicketContent from "../../../components/ticket/TicketContent";
import TicketList from "../../../components/ticket/TicketList";

function Ticket() {
  let navigate = useNavigate();

  const [mainCardHeight, setMainCardHeight] = useState(0);

  const [selectedTicket, setSelectedTicket] = useState(null);

  useEffect(() => {
    let element = document.getElementById("tickets-main-card");

    //
    setMainCardHeight(element.clientHeight);
    const handleResizeWindow = () => setMainCardHeight(element.clientHeight);

    // subscribe to window resize event "onComponentDidMount"
    window.addEventListener("resize", handleResizeWindow);
  }, []);

  return (
    <div id="ticket">
      <PageHeader
        title="Ticket (Support Message)"
      >
        <Button
          size="lg"
          variant="white"
          className="with-icon"
          onClick={() => navigate("/app/new-ticket")}
        >
          <i className="lar la-envelope"></i>
          <span className="text-black">New Ticket</span>
        </Button>
      </PageHeader>

      <Card id="tickets-main-card" className="h-100">
        <Row className="h-100">
          <Col
            md={4}
            className={`ticket-list ${
              selectedTicket ? "d-none d-md-block" : ""
            }`}
          >
            <TicketList
              selectedTicket={selectedTicket}
              setSelectedTicket={(item) => setSelectedTicket(item)}
              mainCardHeight={mainCardHeight}
            />
          </Col>
          <Col
            md={8}
            className={`ticket-content ${
              !selectedTicket ? "d-none d-md-block" : ""
            }`}
          >
            <TicketContent
              selectedTicket={selectedTicket}
              setSelectedTicket={(id) => setSelectedTicket(id)}
              mainCardHeight={mainCardHeight}
            />
          </Col>
        </Row>
      </Card>
    </div>
  );
}

export default Ticket;
